import React from "react";
import "./SubUserMobileTable.scss";
import SubUserTableRow from "./SubUserTableRow.js";
import SubUserTableHeader from "./SubUserTableHeader.js";
import {
  tableKeysHelper,
  tableKeysHelperForRemovedUsers,
} from "./TableKeysHelper.js";
import "./SubUserTable.scss";
import { useProfile } from "contexts/profileContext/profileContext.js";

const SubUserTableContainerDesktop = ({
  currentPage,
  sizeNumber,
  setLoading,
  setSubUsers,
  subUsers,
  setNumberOfUsers,
  fieldToOrder,
  orderAscending,
  setFieldFilter,
}) => {
  const { getStatusFilter } = useProfile();
  const showRemovedUsers = getStatusFilter()?.includes("removed");
  const tableKeys = showRemovedUsers
    ? tableKeysHelperForRemovedUsers
    : tableKeysHelper;

  return (
    <div className="sub-user-table-desktop">
      <div
        className={`sub-user-table-desktop-headers ${
          showRemovedUsers ? "sub-users-removed" : ""
        }`}
      >
        <SubUserTableHeader
          tableKeysHelper={tableKeys}
          setFieldFilter={setFieldFilter}
          fieldToOrder={fieldToOrder}
          orderAscending={orderAscending}
        />
      </div>
      {
        <div className="sub-user-table-desktop-rows">
          {subUsers.map((item, index) => {
            return (
              <div
                className={`sub-user-table-desktop-row ${
                  showRemovedUsers ? "sub-users-removed" : ""
                }`}
                key={index}
              >
                <SubUserTableRow
                  item={item}
                  currentPage={currentPage}
                  sizeNumber={sizeNumber}
                  setLoading={setLoading}
                  setSubUsers={setSubUsers}
                  setNumberOfUsers={setNumberOfUsers}
                  fieldToOrder={fieldToOrder}
                  orderAscending={orderAscending}
                />
              </div>
            );
          })}
        </div>
      }
    </div>
  );
};

export default SubUserTableContainerDesktop;
